<template>
  <div>
    <div class="p-mt-6 p-mb-5 text-title">
      Vous n'êtes pas assuré(e) bris de glace,<br />
      nous vous proposons d'obtenir un devis ou de prendre rendez-vous
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-3 p-md-offset-3">
        <Card class="choice-card" @click="selectType(1)">
          <template #content>
            <div class="p-d-flex p-flex-column">
              <div>Je souhaite obtenir un devis</div>
              <i class="pi pi-user-edit" />
            </div>
            <RadioButton
              id="quote"
              name="typeOfProblem"
              value="1"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3"
            />
          </template>
        </Card>
      </div>
      <div class="p-col-12 p-md-3">
        <Card class="choice-card last-choice-card" @click="selectType(2)">
          <template #content>
            <div class="p-d-flex p-flex-column">
              <div>Je souhaite prendre rendez-vous</div>
              <i class="pi pi-calendar-times" />
            </div>
            <RadioButton
              id="appointment"
              name="typeOfProblem"
              value="2"
              v-model="typeOfProblem"
              class="p-my-3 p-my-sm-3"
            />
          </template>
        </Card>
      </div>
    </div>

    <small
      v-if="
        intervention.typeOfProblem.$invalid && intervention.typeOfProblem.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner une option
    </small>

    <div class="p-d-flex p-flex-column p-ai-center">
      <div class="p-d-inline-flex p-jc-center p-my-6" style="width: 60%">
        <div class="p-mt-sm-3 p-mr-5">
          <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
        </div>
        <div class="p-mt-sm-3">
          <Button class="button-navigate" @click="onNext">Suivant</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepSides",

  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfProblem = ref(null);

    const rules = {
      typeOfProblem: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfProblem,
    });

    const getNextUrl = () => {
      let nextUrl = null;
      switch (typeOfProblem.value) {
        case "1":
          nextUrl = "/mon-rendez-vous";
          appointmentStore.appointment.request_type = "quote";
          break;
        case "2":
          nextUrl = "/mon-rendez-vous";
          appointmentStore.appointment.request_type = "meeting";
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl()
        const target = appointmentStore.appointment.request_type === "quote" ? menuStore.getMenuItemWithUrl(nextUrl, true) : menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/devis-ou-rendez-vous',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };

    const onPrevious = () => {
      appointmentStore.appointment.request_type = null;
      emit("prevPage", menuStore.currentMenuItem);
    };

    const selectType = (typeId) => {
      typeOfProblem.value = `${typeId}`
    }

    return {
      onNext,
      intervention,
      typeOfProblem,
      onPrevious,
      selectType,
    };
  },
};
</script>

<style scoped>
::v-deep(.p-radiobutton .p-radiobutton-box.p-highlight){
  background: white !important;
}
::v-deep(.p-radiobutton-box.p-highlight .p-radiobutton-icon){
  background: var(--main) !important;
}
</style>

<style scoped>
::v-deep(.p-radiobutton .p-radiobutton-box.p-highlight){
  background: white !important;
}
::v-deep(.p-radiobutton-box.p-highlight .p-radiobutton-icon){
  background: black !important;
}
</style>

<style>
.choice-card {
  width: 100% !important;
  background-color: #24a285 !important;
  border-radius: 10px;
}
.choice-card .p-card-body {
  padding: 0px !important;
}
.choice-card .p-card-content {
  color: white !important;
  font-size: 1.5em !important;
  line-height: 1.5em !important;
  margin: 15px !important;
  text-align: center !important;
}
.choice-card .p-card-content .pi {
  color: white !important;
  margin: 5px 0px !important;
  font-size: 1.5em !important;
}
.last-choice-card {
  margin-left: 25px !important;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .last-choice-card {
    margin-left: 0px !important;
  }
}
</style>
